import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_approval_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  submitter_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  submitter_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submitter_designation_code: fromDatatype.VarcharDatatypeInterface;
  submitter_code: fromDatatype.VarcharDatatypeInterface;
  submitter_name: fromDatatype.VarcharDatatypeInterface;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  total_required_approval_level: fromDatatype.NumericDatatypeInterface;
  doc_hdr_amount_txn: fromDatatype.NumericDatatypeInterface;
  date_submission: fromDatatype.TimestampTzDatatypeInterface;
  submission_remarks: fromDatatype.TextDatatypeInterface;
  date_withdrawal: fromDatatype.TimestampTzDatatypeInterface;
  withdrawal_remarks: fromDatatype.TextDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  approval_remarks: fromDatatype.TextDatatypeInterface;
  date_final_approval: fromDatatype.TimestampTzDatatypeInterface;
  is_rejected: boolean;
  date_rejection: fromDatatype.TimestampTzDatatypeInterface;
  rejection_remarks: fromDatatype.TextDatatypeInterface;
  date_resubmission: fromDatatype.TimestampTzDatatypeInterface;
  date_void: fromDatatype.TimestampTzDatatypeInterface;
  approval_sequence_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_error: fromDatatype.VarcharDatatypeInterface;
  approval_processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_processor_error: fromDatatype.VarcharDatatypeInterface;
  email_notification_posting_status: fromDatatype.VarcharDatatypeInterface;
  email_notification_error: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  is_document_conversion_required: boolean;
  generic_doc_link_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_link_guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  generic_doc_link_server_doc_type_doc_1_hdr: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_approval_hdr_RowClass implements bl_fi_generic_doc_approval_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  submitter_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  submitter_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submitter_designation_code: fromDatatype.VarcharDatatypeInterface;
  submitter_code: fromDatatype.VarcharDatatypeInterface;
  submitter_name: fromDatatype.VarcharDatatypeInterface;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  total_required_approval_level: fromDatatype.NumericDatatypeInterface;
  doc_hdr_amount_txn: fromDatatype.NumericDatatypeInterface;
  date_submission: fromDatatype.TimestampTzDatatypeInterface;
  submission_remarks: fromDatatype.TextDatatypeInterface;
  date_withdrawal: fromDatatype.TimestampTzDatatypeInterface;
  withdrawal_remarks: fromDatatype.TextDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  approval_remarks: fromDatatype.TextDatatypeInterface;
  date_final_approval: fromDatatype.TimestampTzDatatypeInterface;
  is_rejected: boolean;
  date_rejection: fromDatatype.TimestampTzDatatypeInterface;
  rejection_remarks: fromDatatype.TextDatatypeInterface;
  date_resubmission: fromDatatype.TimestampTzDatatypeInterface;
  date_void: fromDatatype.TimestampTzDatatypeInterface;
  approval_sequence_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_error: fromDatatype.VarcharDatatypeInterface;
  approval_processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_processor_error: fromDatatype.VarcharDatatypeInterface;
  email_notification_posting_status: fromDatatype.VarcharDatatypeInterface;
  email_notification_error: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  is_document_conversion_required: boolean;
  generic_doc_link_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_link_guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  generic_doc_link_server_doc_type_doc_1_hdr: fromDatatype.VarcharDatatypeInterface;
}
